import * as React from 'react'
import { helperPlaceholderSVG } from '../../helpers.mod'

export const relatedContentBlock = () => {
  return (
    <section className="block block--related block--related-xl ls-block-spacing">
      <div className="block__inner ls-container">
        <header className="block__header">
          <h2 className="block__title title--l">Related content</h2>
        </header>
        <div className='block__content'>
          <ul className='block__list grid'>
            {relatedContentItem(false, 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros.', false, '/')}
            {relatedContentItem(true, 'Cras mattis consectetur purus sit amet fermentum.', true, '/')}
            {relatedContentItem(false, 'Porta ac consectetur ac, vestibulum at eros.', true, '/')}
            {relatedContentItem(false, 'Dapibus ac facilisis in, egestas eget quam.', false, '/')}
            {relatedContentItem(false, 'Cras justo odio, dapibus ac facilisis in, egestas eget quam.', false, '/')}
            {relatedContentItem(true, 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros.', true, '/')}
            {relatedContentItem(true, 'Cras mattis consectetur purus sit amet fermentum.', true, '/')}
            {relatedContentItem(false, 'Porta ac consectetur ac, vestibulum at eros.', true, '/')}
            {relatedContentItem(false, 'Dapibus ac facilisis in, egestas eget quam.', false, '/')}
            {relatedContentItem(false, 'Cras justo odio, dapibus ac facilisis in, egestas eget quam.', false, '/')}
            {relatedContentItem(true, 'Morbi leo risus, porta ac consectetur ac, vestibulum at eros.', true, '/')}
          </ul>
        </div>
        <footer className="block__footer">
          <button className="link">Load more</button>
        </footer>
      </div>
    </section>
  )
}

export const relatedContentItem = (isUpdate: boolean, title: string, hasTag: boolean, linkUrl: string) => {
  return (
    <li className='grid__item'>
      <article className='grid__article'>
        <div className='grid__content'>
          <header className="grid__header">
            <h3 className="grid__title title--s">{title}</h3>
            <a className="grid__link" href={linkUrl}></a>
          </header>
          {isUpdate &&  
            <time className='grid__date text--s' dateTime="27 november 2020">27 november 2021</time>
          }
        </div>
        <div className='grid__wrap'>
          {hasTag && 
            <div className='grid__tags tags'>
              <span className='grid__tag tag tag--m'>Content type</span>
            </div>
          }
          <div className='grid__visual fit-object'>
            <img loading="lazy" className='grid__image' src={helperPlaceholderSVG({ shape: { width: 1400, height: 875, radius: '0', color: '#e8e8e8' }, text: { color: '#1e1e1e', size: '40px', font: 'Open Sans, sans-serif' } })} alt="Placeholder" />
          </div>
        </div>
      </article>
    </li>
  )
}
